
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/artikel/herausforderungen-bei-der-maschinendatenerfassung",
      function () {
        return require("private-next-pages/[locale]/artikel/herausforderungen-bei-der-maschinendatenerfassung.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/artikel/herausforderungen-bei-der-maschinendatenerfassung"])
      });
    }
  